<template>
  <div class="dashboard-container">
    <adminDashboard />
    <div style="padding: 0 20px">
      <div style="display: flex">
        <div>
          <div style="display: flex;align-items: center;">
            <div style="width: 160px;text-align: end;">波场最后同步时间：</div>
            <span v-if="tronDate"
              >{{ happenTimeFun(tronDate) }} ({{ numTime(tronDate) }}秒前)</span
            >
            <span v-else>无同步状态</span>
          </div>
          <div style="display: flex;align-items: center;">
            <div style="width: 160px;text-align: end;">币安最后同步时间：</div>
            <span v-if="bnbDate"
              >{{ happenTimeFun(bnbDate) }} ({{ numTime(bnbDate) }}秒前)
            </span>
            <span v-else>无同步状态</span>
          </div>
          <div style="display: flex;align-items: center;">
            <div style="width: 160px;text-align: end;">以太坊最后同步时间：</div>
            <span v-if="ethDate"
              >{{ happenTimeFun(ethDate) }} ({{ numTime(ethDate) }}秒前)
            </span>
            <span v-else>无同步状态</span>
          </div>
          <div style="display: flex;align-items: center;">
            <div style="width: 160px;text-align: end;">POL最后同步时间：</div>
            <span v-if="polDate"
              >{{ happenTimeFun(polDate) }} ({{ numTime(polDate) }}秒前)
            </span>
            <span v-else>无同步状态</span>
          </div>
        </div>
        <div style="padding: 0 10px">
          <el-button type="success" size="mini" @click="tronscanValue"
            >刷新</el-button
          >
        </div>
      </div>
      <div style="margin: 30px 0 10px">语种编号</div>
      <div v-for="(item,index) in tableData" :key="index">{{item}}</div>

    </div>
    <!-- <el-button @click="fuck">123123</el-button> -->
    <!-- <component :is="currentRole" /> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import adminDashboard from "./admin";
// import editorDashboard from './editor'

export default {
  components: { adminDashboard },
  data() {
    return {
      currentRole: "adminDashboard",
      bnbDate: 0,
      tronDate: 0,
      ethDate: 0,
      nowDate: 0,
      polDate:0,
      tableData: [],
      time: null,
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.$api.operate.content()
        .then((res) => {
          this.tableData = res.langStrs;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    this.tronscanValue();
  },
  methods: {
    // fuck(){
    //   this.$message.success({
    //     duration:0,
    //     message:'123123123'
    //   })
    // }
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
    numTime(time) {
      if (time) {
        return ((this.nowDate - time) / 1000).toFixed(0);
      }
    },
    tronscanValue() {
      this.$api.operate
        .tronscanValue()
        .then((res) => {
          this.nowDate = res.nowDate;
          this.bnbDate = res.bnbDate;
          this.tronDate = res.tronDate;
          this.ethDate = res.ethDate;
          this.polDate = res.polDate;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
